import labellist from "./labellist.js";
import labeldetail from "./labeldetail.js";
import editlabel from "./editlabel.js";
import addlabel from "./addlabel.js";

export default {
  labellist,
  labeldetail,
  editlabel,
  addlabel,
};
